import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Card, { ICardProps } from '../card/card';
import { useResponsiveHelper } from '@myinnsworth/hooks/responsiveHelperHook';
import { useEffect, useState } from 'react';

export interface IInnsworthSlilderProps {
    cards: Array<ICardProps>;
}

export default function InnsworthSlider(props: IInnsworthSlilderProps) {
    const { isResponsive } = useResponsiveHelper();
    const [sliderSettings, setSliderSettings] = useState<any>({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: isResponsive ? 1 : 3,
        slidesToScroll: 1,
        arrows: false
    });

    useEffect(() => {
        setSliderSettings({
            ...sliderSettings,
            slidesToShow: isResponsive ? 1 : 3,
        });
    }, [isResponsive]);

    return (
        <div className='slider-container'>
            <Slider {...sliderSettings}>
                {props.cards.map((card: ICardProps, idx: number) => (<Card key={idx} {...card} />))}
            </Slider>
        </div>
    );
}